/* eslint-disable import/no-duplicates */
import Account from '@atom-web/icons-24/Account'
import { Box, Flex } from '@atom-web/micros'
import Image from 'next/image'
import { useState } from 'react'

import clearImagePath from '../../../utils/clearImagePath'

const UserAvatar = ({ profileImage, wrapperStyle }) => {
	const [error, setError] = useState(false)

	return !error && profileImage?.length ? (
		<Box
			css={{
				borderRadius: '100%',
				overflow: 'hidden',
				position: 'relative',
				width: '48px',
				height: '48px',
				'@sm': {
					width: '64px',
					height: '64px',
				},
				...wrapperStyle,
			}}
		>
			<Image
				src={clearImagePath(profileImage, 'images')}
				layout="fill"
				objectFit="cover"
				onError={() => setError(true)}
			/>
		</Box>
	) : (
		<Flex
			css={{
				borderRadius: '100%',
				overflow: 'hidden',
				position: 'relative',
				width: '48px',
				height: '48px',
				backgroundColor: '$primary02',
				'@sm': {
					width: '64px',
					height: '64px',
				},
			}}
			align="center"
			justify={'center'}
		>
			<Box css={{ display: 'inline-flex', '@sm': { display: 'none' } }}>
				<Account fill="#fff" width="24px" height="24px" />
			</Box>
			<Box css={{ display: 'none', '@sm': { display: 'inline-flex' } }}>
				<Account fill="#fff" width="32px" height="32px" />
			</Box>
		</Flex>
	)
}

export default UserAvatar
